import { render, staticRenderFns } from "./TotalSectionExportLegend.vue?vue&type=template&id=109215cd&scoped=true&"
import script from "./TotalSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./TotalSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109215cd",
  null
  
)

export default component.exports